<template>
  <v-container fluid v-if="customer">
    <snackbar-queue v-model="messages"></snackbar-queue>
    <div class="text-center">
      <h1>Segment Export {{ customer.name }}</h1>
      <p>exporting Braze user segments</p>
    </div>
    <div class="ma-5">
      <div v-if="customer && !customer.segments">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <div v-if="customer && customer.segments">
        <v-row class="ma-1">
          <h3>
            Select Segment
          </h3>
          <v-btn icon @click="loadSegments()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-row>
        <v-select v-model="selected_segment" :items="customer.segments" item-value="id" item-text="name"></v-select>
        <div>
          <div v-if="user_preview_loading">
            <v-progress-linear indeterminate></v-progress-linear>
          </div>
          <div class="user_preview" v-else-if="user_preview != null && !user_preview_loading">
            <h3>
              Segment Details
              <v-btn icon @click="loadUserpreview()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </h3>
            <div class="segment_stats bottom_separated">
              Total Segment Users: {{ user_preview }}
            </div>
          </div>
        </div>
        <v-combobox class="my-5" v-model="fields_to_export" multiple chips clearable deletable-chips
          label="Fields to Export" hint="Press Enter to add"></v-combobox>
        <v-btn color="green" @click="execute_job()">Run Export</v-btn>
      </div>
    </div>
    <div class="ma-5">
      <h2>
        Segment Downloads
        <v-btn icon @click="loadSegmentDownloads()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </h2>
      <div v-if="downloads">
        <v-expansion-panels multiple focusable inset>
          <v-expansion-panel v-for="(value, index) in downloads" :key="index">
            <v-expansion-panel-header>
              <span><b>{{ value.name }}</b></span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <b>Segment Name:</b> {{ value.name }}
              <br />
              <b>Segment ID:</b> {{ value.id }}
              <br />
              <b>Export Time:</b> {{ value.time }}
              <br />
              <a :href="value.url" target="_blank">Download URL</a>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div v-else>
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
    </div>
  </v-container>
</template>
<script>
import SnackBarQueue from "../helpers/SnackBarQueue";

export default {
  props: ["mandator"],
  components: {
    "snackbar-queue": SnackBarQueue,
  },
  data() {
    return {
      messages: [],
      selected_segment: "",
      downloads: [],
      fields_to_export: ["braze_id", "external_id", "email",],
      user_preview: null,
      user_preview_loading: false,
    };
  },
  computed: {
    customer() {
      return this.$store.getters.customer(this.mandator);
    }
  },
  watch: {
    selected_segment: function (new_segment) {
      this.loadUserpreview();
    },
  },

  methods: {
    loadSegmentDownloads() {
      try {
        this.downloads = null;
        this.axios
          .get(`/customers/segment-downloads`, {
            params: {
              mandator: this.customer.mandator,
            },
          })
          .then((result) => {
            this.downloads = result.data;
            this.messages.push("Loaded downloads!")
          })
          .catch((err) => {
            console.error(err);
            this.messages.push({
              message: `Failed loading segment downloads! ${err.response ? err.response.data.message : err.message}`,
              color: "error",
            });
            this.downloads = [];
          });
      } catch (err) {
        console.error(err);
        this.messages.push({
          message: `Failed loading segment downloads! ${err.response ? err.response.data.message : err.message}`,
          color: "error",
        });
        this.downloads = [];
      }
    },
    loadSegments() {
      try {
        this.$store.dispatch("loadSegmentsForCustomer", this.customer.mandator);
      } catch (err) {
        console.error(err);
        this.messages.push({
          message: `Failed loading segments! ${err.response ? err.response.data.message : err.message}`,
          color: "error",
        });
      }
    },
    loadUserpreview() {
      if (this.customer && this.customer.segments && this.selected_segment != "") {
        this.user_preview = null;
        this.user_preview_loading = true;
        this.axios
          .get(`/customers/segment-user-preview`, {
            params: {
              mandator: this.customer.mandator,
              segmentId: this.selected_segment,
            },
          })
          .then((result) => {
            this.user_preview = result.data.size;
            this.user_preview_loading = false;
          })
          .catch((err) => {
            console.error(err);
            this.messages.push({
              message: `Failed loading Segment Preview! ${err.response ? err.response.data.message : err.message}`,
              color: "error",
            });
            this.user_preview_loading = false;
          });
      }
    },
    execute_job() {
      if (
        this.customer &&
        this.customer.segments &&
        this.selected_segment != "" &&
        this.user_preview != null
      ) {
        try {
          var segment = this.customer.segments.find((segment) => {
            return segment.id == this.selected_segment;
          });
          this.axios
            .post(`/customers/segment-export`, {
              mandator: this.customer.mandator,
              segmentId: segment.id,
              segmentName: segment.name,
              fields_to_export: this.fields_to_export
            })
            .then((result) => {
              this.messages.push(`${result.data.message}`);
            })
            .catch((err) => {
              console.error(err);
              this.messages.push({
                message: `Failed executing job! ${err.response ? err.response.data.message : err.message}`,
                color: "error",
              });
            });
        } catch (err) {
          console.error(err);
          this.messages.push({
            message: `Failed executing job! ${err.response ? err.response.data.message : err.message}`,
            color: "error",
          });
        }
      } else {
        this.messages.push({
          message: `Couldn't start Job - there are still JSON errors or no segment is selected!`,
          color: "error",
        });
      }
    },
  },
  created() {
    if (this.customer && !this.customer.segments) {
      this.loadSegments();
      this.loadSegmentDownloads();
    }
  },
};
</script>
<style>
.bottom_separated {
  border-bottom: 1px solid #42b983;
}

textarea {
  resize: none;
  width: 50%;
  height: 20em;
  font-size: 1em;
}

.error {
  color: darkred;
}

.toggler {
  cursor: pointer;
}

.job {
  width: 50%;
}

.job_header {
  display: flex;
  justify-content: space-between;
}

.job_overview {
  display: flex;
}

.job_details {
  margin-left: 10px;
}

.job_message {
  margin: 10px;
}

.progress_bar_container {
  width: 300px;
  height: 1em;
  padding: 0;
  border: gray 1px solid;
}

.progress_bar {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
